import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { formatValidationTypeList } from 'sharedParts';

import { ConditionalQuestionLabel } from 'components/ConditionalQuestion';
import generateQuestionFormName from 'utils/generateQuestionFormName';
import emptyAnswer from 'config/emptyAnswer';
import { getInputTypeFromFormatValidator } from 'config/fieldFormatValidationConfig';

import TextQuestionForm from './TextQuestionForm';
import TextQuestionRichText from '../../domains/richText/components/TextQuestionRichText';

import { questionLayoutPropType } from '../../config/richTextConfig/questionLayout';
import FormTextFieldWithStyleInline from '../../domains/styling/components/FormTextFieldWithStyleInline';
import propTypeBlockStyling from '../../domains/styling/config/editorBlock/PropTypes/blockStyling';

const ShortTextQuestion = ({
  block,
  block: { clientUuid, required, content, formatValidationType },
  isInPreviewMode = false,
  isCloned,
  onAnswer,
  answer = emptyAnswer,
  layout,
  styling,
  questionNumber,
}) => {
  const isConditionalQuestion = useMemo(() => !!(block.logic && block.logic.message), [block.logic]);

  return (
    <div>
      {isInPreviewMode &&
        isConditionalQuestion && <ConditionalQuestionLabel enableMessage={block.logic.message} />}
      <TextQuestionRichText
        questionNumber={questionNumber}
        layout={layout}
        content={content}
        required={required}
        styling={styling}
      />
      <TextQuestionForm
        layout={layout}
        form={generateQuestionFormName(clientUuid, isCloned)}
        block={block}
        inputType={getInputTypeFromFormatValidator(formatValidationType)}
        FieldComponent={FormTextFieldWithStyleInline}
        onSubmit={onAnswer}
        initialValues={answer}
        styling={styling}
      />
    </div>
  );
};

ShortTextQuestion.propTypes = {
  block: PropTypes.shape({
    clientUuid: PropTypes.string.isRequired,
    required: PropTypes.bool,
    content: PropTypes.object,
    formatValidationType: PropTypes.oneOf(Object.keys(formatValidationTypeList)),
  }).isRequired,
  isCloned: PropTypes.bool,
  isInPreviewMode: PropTypes.bool,
  layout: questionLayoutPropType,
  onAnswer: PropTypes.func.isRequired,
  answer: PropTypes.shape({
    value: PropTypes.string,
  }),
  styling: propTypeBlockStyling,
  questionNumber: PropTypes.number,
};

export default ShortTextQuestion;
